import {apiCall} from "./apicall";

export async function fetchLocations() {
    return await apiCall("/locations");
}

export async function fetchLocation(id) {
    return await apiCall(`/locations/${id}`);
}

export async function deleteLocation(id) {
    return await apiCall("/locations/"+id, {method: "DELETE"});
}

export async function updateLocation(body){
    return await apiCall(`/locations/${body.LocationID}`, {method: "PUT"}, body);
}

export async function newLocation(){
    return await apiCall("/locations", {method:"POST"});
}

export async function getCodes(LocationID){
    //return console.log(`/locations/${LocationID}/codes`)
    return await apiCall(`/locations/${LocationID}/codes`, {method: "GET"});
}

export async function deleteCode(LocationID, CodeID) {
    //return console.log(`/locations/${LocationID}/codes/${CodeID}`)
    return await apiCall(`/locations/${LocationID}/codes/${CodeID}`, {method: "DELETE"});
}

export async function addCode(body){
    return await apiCall(`/locations/${body.LocationID}/codes`, {method: "POST"}, body);
}

export async function getStaff(LocationID){
    return await apiCall(`/locations/${LocationID}/staff`)
}

export async function deleteStaff(LocationID, UserID){
    return await apiCall(`/locations/${LocationID}/staff/${UserID}`, {method: "DELETE"});
}

export async function addStaff(LocationID, UserID){
    return await apiCall(`/locations/${LocationID}/staff`, {method: "POST"}, {UserID});
}
